var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-check-in" },
    [
      _vm._l(_vm.list, function (item, index) {
        return _c("div", { key: index, staticClass: "check-in" }, [
          _c("div", [
            _c("span", { staticClass: "lable" }, [_vm._v("房源编号：")]),
            _vm._v(_vm._s(item.bianhao)),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "lable" }, [_vm._v("房源标题：")]),
            _vm._v(_vm._s(item.title)),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "lable" }, [_vm._v("小区名称：")]),
            _vm._v(_vm._s(item.xiaoqumingcheng_id)),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "lable" }, [_vm._v("用户：")]),
            _c("a", { attrs: { href: "tel:" + item.kyphone } }, [
              _vm._v(_vm._s(item.kyphone)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "lable" }, [_vm._v("打卡时间：")]),
            _vm._v(_vm._s(item.dk_time)),
          ]),
        ])
      }),
      _vm._v(" "),
      !_vm.list
        ? _c("div", { staticClass: "my-check-in-null" }, [
            _vm._v("数据加载中..."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.list && _vm.list.length == 0
        ? _c("div", { staticClass: "my-check-in-null" }, [
            _vm._v("暂无打卡记录"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }